export class uppercaseValueConverter {
  toView(value: string) {
    return value?.toUpperCase();
  }
}
